import React from 'react';
import TabsComponent from '../tab/tab.jsx';

const GrowthPost = (props) => {
  return <TabsComponent {...props} />;
};

export default GrowthPost;
